// Import React core library
import React from 'react';
// Import the ReactTyped component (typing animation) from react-typed
import { ReactTyped } from 'react-typed';
// Import the homepage image asset
import homepage from '../assets/Home.png';

// Define the Home component
const Home = () => {
  // Return the JSX to render
  return (
    // Top-level section with full viewport height, centered on mobile, row layout on desktop with space-between, and hidden overflow
    <section
      id="home"
      className="h-screen flex flex-col justify-center md:flex-row md:justify-between relative overflow-hidden"
    >
      {/* Image Section: appears at top on mobile, right on desktop */}
      <div
        className="
          w-full               /* full width on mobile */
          md:w-1/2             /* half width on desktop */
          flex                 /* flex container */
          justify-center       /* center horizontally */
          items-center         /* center vertically */
          md:order-2           /* move to second position on desktop */
          px-4 py-4            /* consistent padding on mobile */
          md:p-6               /* padding on desktop */
        "
      >
        {/* Render the homepage image with responsive sizing */}
        <img
          src={homepage}
          alt="Homepage Visual"
          className="
            w-full               /* full width on mobile */
            h-auto               /* auto height to maintain aspect ratio */
            md:h-full            /* full height on desktop */
            md:w-auto            /* auto width on desktop */
            object-contain       /* scale to fit container without cropping */
          "
        />
      </div>

      {/* Text Section: appears at bottom on mobile, left on desktop */}
      <div
        className="
          w-full               /* full width on mobile */
          md:w-1/2             /* half width on desktop */
          flex                 /* flex container */
          justify-center       /* center horizontally */
          items-center         /* center vertically */
          bg-transparent
          md:bg-lavender       /* background color on desktop */
          px-4 py-4            /* padding on mobile */
          md:px-8 md:py-0      /* horizontal padding on desktop, no vertical */
          relative z-0         /* stacking context */
        "
      >
        {/* Heading with responsive font sizes, custom font, color, and centered text */}
        <h1
          className="
            text-5xl             /* base font size on mobile */
            sm:text-3xl
            md:text-5xl          /* font size on small desktops */
            lg:text-7xl          /* font size on large desktops */
            2xl:text-8xl         /* font size on extra-large screens */
            font-bold            /* bold text */
            font-ubuntu          /* custom font family */
            text-deepIndigo      /* custom text color */
            text-center          /* center align text */
          "
          style={{ lineHeight: 1.25 }}  /* custom line height */
        >
          {/* ReactTyped for typing animation: strings, speeds, loop, and span wrapper */}
          <ReactTyped
            strings={[
              'Unlock <span class="text-electricViolet">Value</span> Through<span class="text-electricViolet"> Innovative</span> Insights!',
            ]}
            typeSpeed={120}   /* typing speed in ms */
            backSpeed={30}    /* backspace speed in ms  */
            backDelay={2000}  /* delay before backspacing in ms */
            loop              /* loop the animation */
            wrapper="span"  /* render inside a <span> tag */
          />
        </h1>
      </div>
    </section>
  );
};

// Export the Home component as the default export
export default Home;
